<template>
    <div :class="{ 'header-fixed': fixed }">
        <v-layout class="cookie-summary" align-center v-if="showCookie">
            <v-flex class="cookie-summary-info">
                {{ $t("nav.cookie") }}
            </v-flex>
            <v-flex shrink>
                <button class="button ok-button" @click="closeCookie">
                    {{ $t("nav.ok") }}
                </button>
            </v-flex>
        </v-layout>
        <v-layout class="header" justify-space-between>
            <v-layout shrink>
                <router-link class="brand" :to="{ name: 'home' }">
                    <img class="logo" :src="logo" alt=""/>
                </router-link>
            </v-layout>

            <v-layout align-center shrink class="max-container">
                <v-layout class="navigation">
                    <router-link :to="{ name: 'index' }" v-if="storeInfo.showStart">
                        {{ $t("nav.zipcode") }}
                    </router-link>
                    <v-layout class="navigation">
                        <router-link :to="{ name: 'about' }" v-if="storeInfo.showAboutMe">{{
                                $t("nav.about")
                            }}
                        </router-link>
                    </v-layout>
                    <v-layout class="navigation" v-if="storeInfo.reserveStatus == 1">
                        <router-link :to="{ name: 'reservar' }">{{
                                $t("nav.reservar")
                            }}
                        </router-link>
                    </v-layout>
                    <router-link :to="{ name: 'home' }">
                        {{ $t("nav.delivery") }}
                    </router-link>
                    <router-link :to="{ name: 'account/info' }" v-if="isLogin">
                        {{ userInfo && userInfo.email }}
                    </router-link>
                    <a href="javascript:;" class="language-con" v-if="languageList && languageList.length>1">
                        <span class="text">{{ languageListText[getLanguageIndex] }}</span>
                        <ul class="language-ul language-ul1">
                            <li v-for="(item, index) in languageList" :key="'lan_' + index"
                                v-show="item.enable"
                                @click="handleChangeLanguage(languageListVal[item.val - 1])">{{ languageListText[item.val - 1] }}</li>
                        </ul>
                    </a>
                </v-layout>

                <v-layout v-if="!isLogin">
                    <router-link
                        class="button shadow login-button"
                        :to="{ name: 'login' }"
                    >
                        {{ $t("nav.login") }}
                    </router-link>
                </v-layout>
            </v-layout>

            <v-layout align-center shrink justify-center class="min-container">
                <v-toolbar color="transparent" flat @click="handleShowMenu">
                    <img class="icon" src="../../assets/menu.png"/>
                </v-toolbar>
            </v-layout>
        </v-layout>
        <div class="announcement-container" v-if="storeInfo.storeConf && storeInfo.storeConf.isAnnouncement">
            <div class="animation">
                <div>
                    <div>{{ storeInfo.storeConf.announcement }}</div>
                    <div>{{ storeInfo.storeConf.announcement }}</div>
                </div>
            </div>
        </div>
        <v-layout
            align-center
            shrink
            class="min-content"
            column
            v-if="showMenu"
            @click="hideShowMenu"
        >
            <v-layout class="navigation">
                <router-link :to="{ name: 'index' }" v-if="storeInfo.showStart">{{
                        $t("nav.zipcode")
                    }}
                </router-link>
            </v-layout>
            <v-layout class="navigation">
                <router-link :to="{ name: 'about' }">{{ $t("nav.about") }}</router-link>
            </v-layout>
            <v-layout class="navigation" v-if="storeInfo.reserveStatus == 1">
                <router-link :to="{ name: 'reservar' }">{{ $t("nav.reservar") }}</router-link>
            </v-layout>
            <v-layout class="navigation" v-if="storeInfo.takeawayStatus != 0">
                <router-link :to="{ name: 'home' }">
                    {{ $t("nav.delivery") }}
                </router-link>
            </v-layout>
            <v-layout class="navigation" v-if="isLogin">
                <router-link :to="{ name: 'account/info' }">
                    {{ userInfo && userInfo.email }}
                </router-link>
            </v-layout>
            <v-layout class="navigation" v-if="!isLogin">
                <router-link :to="{ name: 'login' }">
                    {{ $t("nav.login") }}
                </router-link>
            </v-layout>
            <v-layout class="navigation">
                <a href="javascript:;" class="language-con" v-if="languageList && languageList.length>1" @click.stop="openlanguageModal">
                    <span class="text">{{ languageListText[getLanguageIndex] }}</span>
                    <ul class="language-ul" v-show="languageModalVisible">
                        <li v-for="(item, index) in languageList" :key="'lan_' + index"
                            v-show="item.enable"
                            @click="handleChangeLanguage(languageListVal[item.val - 1])">{{ languageListText[item.val - 1] }}</li>
                    </ul>
                </a>
            </v-layout>
        </v-layout>
    </div>
</template>

<script>
import {mapState, mapMutations, mapGetters} from "vuex";
import { Icon } from 'vant';

export default {
    components: {
        vanIcon: Icon
    },
    props: {
        fixed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            languageModalVisible: false, //是否显示语言弹出框
            showMenu: false,
            items: [{title: "Click Me"}, {title: "Click Me 2"}],
            languageListZh: ['西班牙语', '意大利语', '葡萄牙语', '英语', '法语', '德语', '中文'],
            languageListText: ['Spanish', 'Italiano', 'Português', 'English', 'Français', 'Deutsch', '简体中文']
        };
    },
    computed: {
        ...mapGetters(["getLanguageIndex"]),
        ...mapState([
            "guid",
            "tokenContent",
            "userInfo",
            "showCookie",
            "isLogin",
            "language",
            "languages",
            "storeInfo",
            "languageList",
            "languageListVal"
        ]),
        logo() {
            let logo = "";
            this.storeInfo &&
            this.storeInfo.images &&
            this.storeInfo.images.map(item => {
                if (item.imageType == 0) {
                    logo = item.url;
                }
            });
            return logo;
        }
    },
    methods: {
        ...mapMutations(["closeCookie", "setLanguage"]),
        handleShowMenu() {
            this.showMenu = !this.showMenu;
            this.languageModalVisible = false;
        },
        hideShowMenu() {
            this.showMenu = false;
            this.languageModalVisible = false;
        },
        openlanguageModal(){
            this.languageModalVisible = !this.languageModalVisible
        },
        handleChangeLanguage(language) {
            this.setLanguage(language);
            this.$i18n.locale = language;
            this.languageModalVisible = false;
            localStorage.setItem('language', language);
        }
    }
};
</script>

<style scoped lang="sass" src="./navigation.sass"></style>
